import type { AppDefinition } from '../types';
import { AppCard } from './AppCard';

export interface AppGridProps {
  apps: AppDefinition[];
  showStar: boolean;
  isFav: (id: string) => boolean;
  onToggleFav: (id: string) => void;
}

export function AppGrid({ apps, showStar, isFav, onToggleFav }: AppGridProps) {
  return (
    <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-3">
      {apps.map((app) => (
        <AppCard
          key={app.id}
          app={app}
          showStar={showStar}
          isFav={isFav(app.id)}
          onToggleFav={() => onToggleFav(app.id)}
        />
      ))}
    </div>
  );
}
